export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd726376eff92b7884a29d74e0f58fd7dffbb2841&name=fetchTypeahead!'